import dayjs from 'dayjs'
import 'dayjs/locale/vi'

dayjs.locale('vi')

export function formatDate(d: string | Date | null | undefined, fmt = 'DD/MM/YYYY'): string {
  if (!d) return ''
  const m = dayjs(d)
  return m.isValid() ? m.format(fmt) : ''
}

export function formatDateTime(d: string | Date | null | undefined): string {
  return formatDate(d, 'DD/MM/YYYY HH:mm')
}

export function toIsoDate(d: dayjs.Dayjs | Date | null | undefined): string | null {
  if (!d) return null
  const m = dayjs(d)
  return m.isValid() ? m.format('YYYY-MM-DD') : null
}
